import { Search } from "lucide-react"
import { Input } from "@/modules/shared/ui/components/input"
import { Badge } from "@/modules/shared/ui/components/badge"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/modules/shared/ui/components/select"

export interface FilterOption {
  label: string
  value: string
}

interface SearchFilterBarProps {
  searchValue: string
  onSearchChange: (value: string) => void
  searchPlaceholder?: string
  filterValue: string
  onFilterChange: (value: string) => void
  filterOptions: FilterOption[]
  filterPlaceholder?: string
  count?: number
  countLabel?: string
  hasData: boolean
  defaultFilterValue?: string
}

export function SearchFilterBar({
  searchValue,
  onSearchChange,
  searchPlaceholder = "Search...",
  filterValue,
  onFilterChange,
  filterOptions,
  filterPlaceholder = "Filter",
  count,
  countLabel,
  hasData,
  defaultFilterValue = "all",
}: SearchFilterBarProps) {
  const isFilterActive = filterValue !== defaultFilterValue
  if (!hasData && !searchValue && !isFilterActive) return null

  return (
    <div className="flex items-center gap-3 mt-4">
      <div className="relative max-w-xl flex-1">
        <Search className="w-4 h-4 text-muted-foreground absolute left-3 top-1/2 -translate-y-1/2" />
        <Input
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={searchPlaceholder}
          className="pl-9"
        />
      </div>
      <Select value={filterValue} onValueChange={onFilterChange}>
        <SelectTrigger className="w-48 bg-background border border-border px-4 py-2 rounded-md shadow-sm focus:ring-2 focus:ring-ring focus:border-ring">
          <SelectValue placeholder={filterPlaceholder} />
        </SelectTrigger>
        <SelectContent className="bg-popover">
          {filterOptions.map((opt) => (
            <SelectItem className="hover:bg-accent" key={opt.value} value={opt.value}>
              {opt.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {count !== undefined && countLabel && (
        <Badge variant="default" className="px-4 py-2 text-sm whitespace-nowrap">
          {count} {countLabel}
        </Badge>
      )}
    </div>
  )
}
